var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 455,
    height: 455,
    viewBox: "0 0 455 455",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.4 204.35V203.685C246.264 203.908 246.076 204.131 245.958 204.35H246.4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V455H455V0H0ZM141.522 378.002H74.016V174.906H141.522V378.002ZM107.769 147.186H107.323C84.678 147.186 70 131.585 70 112.085C70 92.157 85.107 76.998 108.211 76.998C131.32 76.998 145.521 92.157 145.963 112.085C145.963 131.585 131.32 147.186 107.769 147.186ZM385 378.002H317.476V269.345C317.476 242.054 307.72 223.425 283.281 223.425C264.617 223.425 253.526 235.968 248.64 248.118C246.864 252.458 246.4 258.491 246.4 264.577V378.003H178.863C178.863 378.003 179.768 193.96 178.863 174.907H246.4V203.686C255.373 189.879 271.386 170.139 307.256 170.139C351.693 170.139 385 199.159 385 261.537V378.002Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.7da85fb9282fcf531ada34bb25160efe.svg";
export { ForwardRef as ReactComponent };